import { z } from 'zod';

export type LrpQuoteHistoryResult = {
  coverageValues: {
    coverageValuesMap: {
      [key: number]: {
        premium: number;
        coveragePrice: number;
        expectedEndingValue: number;
      };
    };
    coverageLevels: number[];
  };
};

export const lrpQuoteHistoryResultSchema = z.object({
  coverageValuesMap: z.record(
    z.object({
      premium: z.number(),
      coveragePrice: z.number(),
      expectedEndingValue: z.number(),
    })
  ),
  coverageLevels: z.array(z.number()),
});
